!function() {
  'use strict';

  /*
    Pashion: Override Broadcast's variant availability for Shoes bundle products.

    Broadcast's product-info.js reads the variant JSON (where available=false for
    bundler variants) and disables the ATC button + adds variant--soldout class.
    This script hooks into product-info's postProcessHtmlCallbacks to immediately
    re-enable the button after each DOM swap, eliminating the flash.
  */

  function isShoesBundle(container) {
    var el = (container || document).querySelector('[data-pashion-product-type]');
    return el && el.dataset.pashionProductType === 'Shoes';
  }

  function enableBundleButton(container) {
    var root = container || document.querySelector('product-info');
    if (!root) return;

    var submitBtn = root.querySelector('[data-add-to-cart]');
    if (submitBtn) submitBtn.disabled = false;

    var variantInput = root.querySelector('input.product-variant-id');
    if (variantInput) variantInput.disabled = false;

    var btnText = root.querySelector('[data-add-to-cart-text]');
    if (btnText && window.theme && window.theme.strings) {
      var priceEl = btnText.querySelector('[data-product-price]');
      var priceHTML = priceEl ? priceEl.outerHTML : '';
      btnText.textContent = window.theme.strings.addToCart;
      if (priceHTML) btnText.insertAdjacentHTML('beforeend', ' ' + priceHTML);
    }

    var formWrapper = root.querySelector('[data-form-wrapper]');
    if (formWrapper) formWrapper.classList.remove('variant--soldout');
  }

  function hookIntoProductInfo() {
    if (!isShoesBundle()) return;

    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    // Use postProcessHtmlCallbacks — fires immediately after DOM swap, no delay
    if (productInfo.postProcessHtmlCallbacks) {
      productInfo.postProcessHtmlCallbacks.push(function(newNode) {
        enableBundleButton(newNode || productInfo);
      });
    }

    // Also use preProcessHtmlCallbacks to fix the HTML before it's inserted
    if (productInfo.preProcessHtmlCallbacks) {
      productInfo.preProcessHtmlCallbacks.push(function(newContent) {
        if (!newContent) return;
        // Remove disabled from ATC button and variant input in the incoming HTML
        var btn = newContent.querySelector('[data-add-to-cart]');
        if (btn) btn.removeAttribute('disabled');
        var input = newContent.querySelector('input.product-variant-id');
        if (input) input.removeAttribute('disabled');
        // Remove variant--soldout class from form wrapper
        var wrapper = newContent.querySelector('[data-form-wrapper]');
        if (wrapper) wrapper.classList.remove('variant--soldout');
      });
    }

    // Fix initial state
    enableBundleButton(productInfo);
  }

  // Hook in as soon as product-info is ready
  document.addEventListener('theme:product-info:loaded', hookIntoProductInfo);

  // Also try immediately in case event already fired
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookIntoProductInfo);
  } else {
    hookIntoProductInfo();
  }
}();
